import {Grid, Alert, AlertTitle, Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Skeleton, TextField, Typography } from '@mui/material'

// Shown only when rejecting at the Final Control (last) stage, so the rejecter can choose which
// earlier stage the chain reverts to, instead of always reverting to stage 1. If that chosen stage
// has no working group of its own, a "Previous Approver Group" must also be picked before confirming.
const RevertStageDialog = ({ open, options, value, error, loading, needsWorkingGroup, leaseSlug, workingGroups, groupsLoading, selectedGroup, groupError, onChange, onChangeGroup, onFocusGroup, onCancel, onConfirm }) => {
    if (!open) return null
    const noWorkingGroups = needsWorkingGroup && !groupsLoading && workingGroups.length === 0
    const confirmBlocked = needsWorkingGroup && (groupsLoading || noWorkingGroups)

    return (
        <Dialog open maxWidth='xs' fullWidth>
            <DialogTitle>Reject To Stage</DialogTitle>
            <DialogContent dividers>
                  <Grid container spacing={1} >
                      <Grid size={{ md: 12, xs: 12 }}>
                      <Autocomplete
                size='small'
                    options={options}
                    getOptionLabel={(option) => option?.stage_name || ''}
                    value={value}
                    onChange={(_, val) => onChange(val)}
                    disabled={loading}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            required
                            label='Rejected To'
                            margin='normal'
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            error={!!error}
                            helperText={error}
                            disabled={loading}
                        />
                    )}
                />
                      </Grid>
              
                {needsWorkingGroup && (
                    <Grid size={{ md: 12, xs: 12 }}>
                    <Box sx={{ mt: 1, mb: 2 }}>
                        {groupsLoading ? (
                            <Box sx={{ mt: 1 }}>
                                <Skeleton variant='text' width={140} height={20} />
                                <Skeleton variant='rounded' height={40} sx={{ mt: 0.5 }} />
                            </Box>
                        ) : noWorkingGroups ? (
                            <Alert severity='warning'>
                                <AlertTitle>No Working Group Found</AlertTitle>
                                This lease doesn't have a working group set up yet. Add one before confirming this revert.
                                <Typography
                                    component='span'
                                    variant='inherit'
                                    sx={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}
                                    onClick={() => window.open(`/lease/${leaseSlug}/lease-details/working-groups`, '_blank')}
                                >
                                    Basic Details {'>'} Working Group
                                </Typography>
                            </Alert>
                        ) : (
                            <Autocomplete
                                size='small'
                                disableClearable
                                options={workingGroups}
                                getOptionLabel={(option) => option?.name || ''}
                                isOptionEqualToValue={(option, val) => option?.id === val?.id}
                                value={selectedGroup}
                                onChange={(_, val) => onChangeGroup(val)}
                                disabled={loading}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        required
                                        label='Previous Approver Group'
                                        margin='normal'
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!groupError}
                                        helperText={groupError}
                                        disabled={loading}
                                        onFocus={onFocusGroup}
                                    />
                                )}
                            />
                        )}
                    </Box>
                    </Grid>
                )}


                  </Grid>
               
            </DialogContent>
            <DialogActions sx={{ marginRight: '15px' }}>
                <Button size='small' variant='outlined' onClick={onCancel} disabled={loading}>Cancel</Button>
                <Button size='small' variant='contained' color='error' onClick={onConfirm} disabled={loading || confirmBlocked}>
                    {loading ? <CircularProgress size={18} /> : 'Reject'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default RevertStageDialog
